import { useToast } from "vue-toastification";
import { Capacitor } from "@capacitor/core";
// import { useCapacitorPushNotifications, getLastDeviceId, getLastPushToken } from "@/composables/usePushNotifications";
import { useCapacitorPushNotifications } from "@/composables/usePushNotifications";
// import apiClient from "@/services/axios";
import { subscribeToMercure, unsubscribeFromMercure } from "@/services/mercure";
import { useI18n } from "vue-i18n";



let instance: ReturnType<typeof createMessaging> | null = null;

function createMessaging() {
  const toast = useToast();
  const { t } = useI18n();

  let mercureUnsubscribe: (() => void) | null = null;
  let currentUserIdentifier: string | null = null;

  const registerHandlers = async (user: any) => {
    if (!user?.userIdentifier) return;

    // fix to prevent duplicate subscriptions for same user
    if (currentUserIdentifier === user.userIdentifier && mercureUnsubscribe) {
      return;
    }

    currentUserIdentifier = user.userIdentifier;


    //Native Push notifications only
    if (Capacitor.getPlatform() !== 'web') {
    
      await useCapacitorPushNotifications();
    }


    // Web Mercure subscription  
    if (mercureUnsubscribe) {
      mercureUnsubscribe();
      mercureUnsubscribe = null;
    }

    const eventHandler = (payload: any) => {
      if (!payload?.data || payload.data.type !== "device_status_change") return;

      const data = payload.data;
      const previousStatus = data.changes?.status?.old;
      const newStatus = data.changes?.status?.new;
      const deviceName = data.deviceName;
      // we needed to capitalize the device type "lobas" -> "Lobas"
      const deviceType = typeof data.deviceType === "string" && data.deviceType.length ? data.deviceType[0].toUpperCase() + data.deviceType.slice(1) : "";
      const translationKey = getStatusChangeKey(previousStatus, newStatus);
      // toast.info(
      //   t("notifications.deviceStatusChanged", {
      //     deviceType,
      //     deviceName,
      //     from: t(`device.${previousStatus}`),
      //     to: t(`device.${newStatus}`),
      //   })
      // );
       console.log("Translation Key:", translationKey);
      if (!translationKey) return;
       toast.info(
        t(translationKey, {
          deviceType,
          deviceName,
        })
      );

      window.dispatchEvent(
        new CustomEvent("devices:refresh", {
          detail: { page: 1 }
        })
      );

      // fetchDevices(1, true);
    };

    try {
      mercureUnsubscribe = await subscribeToMercure(user.userIdentifier, eventHandler);
    } catch (err) {
      console.error("Mercure subscription failed:", err);
    }
  };

  const cleanupHandlers = () => {
    currentUserIdentifier = null;

    if (mercureUnsubscribe) {
      mercureUnsubscribe();
      mercureUnsubscribe = null;
    }

    unsubscribeFromMercure();
  };

  function getStatusChangeKey(
    oldStatus?: string,
    newStatus?: string
  ): string | null {
    if (!newStatus) return null;

    const transitionMap: Record<string, string> = {
      "pending->connected": "notifications.status.pending_connected",
      "connected->disconnected": "notifications.status.connected_disconnected",
      "disconnected->connected": "notifications.status.disconnected_connected",
      "connected->connection_lost": "notifications.status.connected_connection_lost",
      "connection_lost->connected": "notifications.status.connection_lost_connected",
      "update_required->connected": "notifications.status.update_required_connected",
      "update_required->disconnected": "notifications.status.update_required_disconnected",
      "connection_lost->disconnected": "notifications.status.connection_lost_disconnected",
    };

    if (oldStatus) {
      const transitionKey = transitionMap[`${oldStatus}->${newStatus}`];
      if (transitionKey) return transitionKey;
    }

    const newStatusMap: Record<string, string> = {
      pending: "notifications.status.pending",
      update_required: "notifications.status.update_required",
    };

    return newStatusMap[newStatus] ?? "notifications.status.fallback";
  }

  return {
    registerHandlers,
    cleanupHandlers,
  };
}

//Public composable (singleton), very important to avoid multiple Mercure subscriptions
export function useMessaging() {
  if (!instance) {
    instance = createMessaging();
  }
  return instance;
}
